import axios from "axios";

export interface UserDetails {
  loggedIn: boolean;
  firstName: string;
  photoURL: string;
  premiumGames: string[];
}

export const initialUserDetails: UserDetails = {
  loggedIn: false,
  firstName: "",
  photoURL: "",
  premiumGames: [],
};

const isLocalhost = () =>
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

export const getAuthServerUrl = (): string =>
  isLocalhost() ? "http://localhost:3000" : "https://auth.teuteuf.fr";

export const getReferer = (): string =>
  isLocalhost() ? "localhost-5173" : "thursday-thirty";

export const refreshTokens = async (): Promise<void> => {
  await axios.post(
    `${getAuthServerUrl()}/auth/refresh`,
    {},
    { withCredentials: true },
  );
};

export const getUserDetails = async (): Promise<{
  firstName: string;
  photoURL: string;
  premiumGames?: string[];
} | null> => {
  const response = await axios.get(`${getAuthServerUrl()}/api/getuser`, {
    withCredentials: true,
  });
  return response.data ?? null;
};

export function getCookie(name: string): string | null {
  if (typeof document === "undefined" || !document.cookie) return null;
  const cookieName = `${name}=`;
  for (const part of document.cookie.split(";")) {
    const trimmed = part.trim();
    if (trimmed.indexOf(cookieName) === 0) {
      return trimmed.substring(cookieName.length);
    }
  }
  return null;
}

export function clearCookie(name: string): void {
  const expiry = "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  // Clear the host-only cookie (e.g. on localhost) and the
  // .teuteuf.fr-domain cookie - only the matching one takes effect.
  document.cookie = name + expiry;
  document.cookie = name + expiry + " domain=.teuteuf.fr;";
}

export function isSameUtcDay(dateString: string): boolean {
  const date = new Date(dateString);
  const now = new Date();
  return (
    date.getUTCFullYear() === now.getUTCFullYear() &&
    date.getUTCMonth() === now.getUTCMonth() &&
    date.getUTCDate() === now.getUTCDate()
  );
}
